module.exports = __webpack_public_path__ + "img/razzo-head-page.b59730f8.webp";